// @flow
export const InitialRequestLocale = {
  form: {
    header: [
      "Please fill and submit the form below to join Envanterium Platform.",
      "Envanterium Online Sayım Platformuna dahil olmak için aşağıdaki formu doldurun."
    ],
    form_unit: {
      header: [
        "Please specify which type of account you are requesting",
        "Lütfen hangi tür hesap talep ettiğinizi belirtin"
      ],
      type: {
        customer: ["Customer Account", "Müşteri Hesabı"],
        partner: ["Partner Account", "Partner Hesabı"]
      },
      full_name: ["Contact Name", "İletişim için Ad-Soyad"],
      email: ["Contact Email", "İletişim için Eposta Adresi"],
      telephone_number: ["Contact Telephone Number", "İletişim için Telefon Numarası"],
      company_name: ["Company Name", "Firma Adı"],
      company_desc: ["Please describe your company shortly", "Lütfen kısaca firmanızı tanıtın."],
      process_requirements: [
        "Please describe your inventory processing needs shortly.",
        "Lütfen kısaca firmanızın envanter sayımı açısından gereksinimlerini anlatın."
      ],
      submit: ["Register", "Kayıt Ol"]
    },
    footer: {
      content: ["Already a Member?", "Zaten Üye misiniz?"],
      login_link: ["Login", "Giriş Yapın"]
    }
  },
  error: {
    header: ["An error occurred when submitting your request.", "Talebinizi oluştururken bir hatayla karşılaştık."],
    content: [
      "There is a big chance that you forgot some of the important fields. Otherwise, our servers could be down. Please try to submit your request again.",
      "Büyük bir ihtimalle gerekli bazı alanları doldurmadınız. Ufak bir ihtimalle de server tarafımızda bazı sorunlar oluştu. Lütfen talebinizi tekrar oluşturun."
    ],
    action: ["Return to Request Form", "Talep Oluşturma Formuna Geri Dön"]
  },
  completed: {
    header: ["We have received your request", "Talebiniz tarafımıza ulaştı"],
    content: [
      "We will contact you in a few days and process your request. On acceptance you will receive an email to guide you to create your company and representative accounts in our system.",
      "Birkaç gün içerisinde sizinle iletişime geçeceğiz ve talebinizi işleme alacağız. Talebinizin onaylanması durumunda alacağınız bir eposta ile sistemimiz üzerinden firma ve temsilci hesaplarınızı oluşturabilirsiniz."
    ]
  }
};



// WEBPACK FOOTER //
// ./src/Locales/PublicAccountPages/InitialRequest.locale.js